export const environment = {
  production: false,
  local: '',
  hw: 'https://doctorcrm.stetho.hindustanlab.com/',
  vs: 'https://video.stetho.hindustanlab.com/',
  oauth: 'http://g1-crm/',
};
